import { createSelector } from '@reduxjs/toolkit';
import { StoreType } from 'store';
import { LoadingStatus } from './types';
import {
  PREFERENCES_LOAD_USER_PREFIX,
  PREFERENCES_SUBSCRIBE_PREFIX,
  PREFERENCES_UNSUBSCRIBE_PREFIX,
} from '../PreferencesCenter/constants';

export const createSelectRequestPendingSelector = (actions: string[]) =>
  createSelector(
    (state: StoreType) => state.app.loading,
    (loading: LoadingStatus) => actions.some((action) => loading[action] === 'pending'),
  );

export const selectPreferencesRequestsPending = createSelectRequestPendingSelector([
  PREFERENCES_LOAD_USER_PREFIX,
  PREFERENCES_SUBSCRIBE_PREFIX,
  PREFERENCES_UNSUBSCRIBE_PREFIX,
]);
